<template>
  <my-chart pageType="chartManage"></my-chart>
</template>

<script>
import MyChart from "@/views/modules/academic/point/myChart.vue";

export default {
    name: "chartManage",
    components: {MyChart}
}
</script>

<style scoped>

</style>